import React from "react";
import { Alert } from "react-native";
import type { StackScreenProps } from "@react-navigation/stack";
import { useTranslations } from "@src/packages/i18n";
import { useFamilyHistory } from "../FamilyHistoryContext";
import { useQueuedPatientUpdate } from "@louise/patients/sync/usePatientSync";
import { transformFamilyHistoryStateToRequest } from "../transformFamilyHistoryStateToRequest";
import {
  BaseCompleteScreen,
  navigateBackToMedicalHistory,
} from "@louise/medical-history/components/BaseCompleteScreen";
import type { FamilyHistoryStackParamList } from "../FamilyHistoryNavigator";

export function FamilyHistoryCompleteScreen({
  navigation,
}: StackScreenProps<FamilyHistoryStackParamList, "FamilyHistoryComplete">) {
  const t = useTranslations();
  const { state } = useFamilyHistory();
  const { mutateAsync: updatePatient, isPending: isUpdatingPatient } =
    useQueuedPatientUpdate();

  const handleFinish = async () => {
    try {
      const payload = transformFamilyHistoryStateToRequest(state);

      await updatePatient(payload);
      navigateBackToMedicalHistory(navigation);
    } catch {
      Alert.alert(
        t("med_history.save_failed_title"),
        t("med_history.save_failed_message"),
        [{ text: t("med_history.save_failed_ok") }],
      );
    }
  };

  return (
    <BaseCompleteScreen
      subtitle={t("med_history.family_history.complete_subtitle")}
      isSubmitting={isUpdatingPatient}
      onFinish={handleFinish}
    />
  );
}
